module.exports = __webpack_public_path__ + "static/media/Portrait-10028.66b9198d.jpg";